import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import AppLayout from "../layouts/AppLayout";
import Product from "../components/Product";
import Pagination from "../components/Pagination";
import { Link } from '@inertiajs/react'
import Category from "../components/Category";
import Advantages from "../components/Advantages";
import Carousel from "../components/Carousel";


export default function Categories({ categories }) {

    return (
        <AppLayout>
            <div className="w-full">
                <div className="container max-w-dasha mx-auto px-4 sm:px-6 lg:px-8 py-20 pt-0 flex flex-col space-y-7">
                    <h1 className="text-3xl font-medium">Categories</h1>
                    <div className="grid grid-cols-1 gap-7 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-8">
                        {categories ? categories.map((category) => {
                            return (
                                <Category category={category} />
                            )
                        }) : null}
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}